import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '~src/ts/fetchers/IListFetcher';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { IPublishedConnectionColumnInfo } from '~src/ts/models/IPublishedConnectionTableInfo';
import { IListResource } from '~src/ts/resources/Resource';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';
import { GetPublishedConnectionColumnsRequest } from '~src/ts/ServerApi/requests/GetPublishedConnectionColumnsRequest';

class PublishedConnectionColumnsResource implements IListResource<IPublishedConnectionColumnInfo> {

  private listFetcher: IListFetcher<IPublishedConnectionColumnInfo> = new WebClientListResourceFetcher(GetPublishedConnectionColumnsRequest, ServerApiMapper.publishedConnectionColumns);

  public all(): ResourceQuery<IPublishedConnectionColumnInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const PublishedConnectionColumns = new PublishedConnectionColumnsResource();
